$(document).ready(function() {
  $(document).on('click', '.read-more-btn span', function(e){
    e.preventDefault()
    var readMore = $('#show-more').html();
    $(this).parent('.read-more-btn').addClass('read-less-btn');
    $(this).parent('.read-more-btn').removeClass('read-more-btn');
    $(this).html('Read less...');
    $('.read-more').html(readMore);
    })
  $(document).on('click', '.read-less-btn span', function(e){
    e.preventDefault()
    var readLess = $('#show-less').html();
    $(this).parent('.read-less-btn').addClass('read-more-btn');
    $(this).parent('.read-less-btn').removeClass('read-less-btn');
    $(this).html('Read more...');
    $('.read-more').html(readLess);
    })
  $('.grandChildMenuDetails summary').click(function(event) {
    event.preventDefault();
    $(this).closest('.grandChildMenuDetails').attr('open', 'open');
    window.location.href = $(this).children('a').attr('href');
  });

});